// extracted by mini-css-extract-plugin
module.exports = {"closeIcon":"styles_closeIcon___pftF","light":"styles_light__v2RZx","dark":"styles_dark__VLCLr"};